export default __webpack_public_path__ + "static/images-0c5a1d12fffc0edbf51697e3095e6b4b.png";